import { render, staticRenderFns } from "./IconPlaySingle.vue?vue&type=template&id=2679f6a3"
import script from "./IconPlaySingle.vue?vue&type=script&lang=js"
export * from "./IconPlaySingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports